module.exports = __webpack_public_path__ + "app-static/img/banner-01.bc3082ec.jpg";